"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TextareaWrapper = _styledComponents["default"].textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  background: ", ";\n  border: solid ", ";\n  border-width: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  width: 100%;\n  padding: ", ";\n  margin: ", ";\n  resize: ", ";\n  transition: border-color ease-in\n    ", ";\n\n  &:focus {\n    outline: 0;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.textareaFontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textareaFontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.textareaFontStyle;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.textareaFontWeight;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.textareaLetterSpacing;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.textareaLineHeight;
}, _utils.getColor, _utils.getColor, _utils.getBackgroundColor, _utils.getBorderColor, function (_ref7) {
  var theme = _ref7.theme,
    readOnly = _ref7.readOnly;
  return (0, _utils.getTextareaBorderWidth)({
    theme: theme,
    readOnly: readOnly
  });
}, function (_ref8) {
  var theme = _ref8.theme,
    readOnly = _ref8.readOnly;
  return (0, _utils.getTextareaBorderRadius)({
    theme: theme,
    readOnly: readOnly
  });
}, function (_ref9) {
  var theme = _ref9.theme,
    readOnly = _ref9.readOnly;
  return readOnly ? theme.textareaPaddingReadOnly : theme.textareaPadding;
}, function (_ref10) {
  var theme = _ref10.theme,
    readOnly = _ref10.readOnly;
  return readOnly ? "-".concat(theme.borderWidth) : 0;
}, function (_ref11) {
  var resize = _ref11.resize;
  return resize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.textareaTransitionTiming;
}, _utils.getFocusedBorderColor, function (_ref13) {
  var theme = _ref13.theme,
    disabled = _ref13.disabled;
  return disabled ? theme.textareaColorDisabled : theme.textareaPlaceholderColor;
}, function (_ref14) {
  var theme = _ref14.theme,
    disabled = _ref14.disabled;
  return disabled ? theme.textareaColorDisabled : theme.textareaPlaceholderColor;
});
var _default = TextareaWrapper;
exports["default"] = _default;